'use client';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function PostFaqList({ faqs }) {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div className="space-y-3">
      {faqs.map((faq, i) => (
        <div key={i} className="border border-slate-200 rounded-xl overflow-hidden">
          <button
            onClick={() => setOpenFaq(openFaq === i ? null : i)}
            className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-slate-50 transition-colors">
            <span className="font-semibold text-slate-900 text-sm pr-4">{faq.question}</span>
            <ChevronDown size={16} className={`text-slate-400 flex-shrink-0 transition-transform ${openFaq === i ? 'rotate-180' : ''}`} />
          </button>
          {openFaq === i && (
            <div className="px-5 pb-4 text-slate-600 text-sm leading-relaxed border-t border-slate-100 pt-3">
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
